import { z } from "zod";

export const TAX_TYPES = ["vat", "none", "custom"] as const;
export const CALCULATION_BASES = ["TOTAL_GROSS", "TOTAL_NET"] as const;
export const PAYMENT_METHOD_TYPES = ["manual", "gateway"] as const;

export const taxConfigSchema = z.object({
  type: z.enum(TAX_TYPES),
  value: z.number().optional(),
});

export const commissionSettingsSchema = z.object({
  percentage: z.number(),
  fixedFee: z.number(),
  tax: taxConfigSchema,
  calculationBase: z.enum(CALCULATION_BASES),
});

export const paymentMethodAdditionalSettingsSchema = z.object({
  commission: commissionSettingsSchema.optional(),
  // snake_case to match the key stored in the DB JSONB (still written by v1)
  logo_url: z.string().optional(),
});

const ticketSectionSchema = z.object({ requires: z.boolean() });

export const ticketConfigSchema = z.object({
  plan: ticketSectionSchema,
  food: ticketSectionSchema,
  merchandise: ticketSectionSchema,
});

export const paymentMethodSchema = z.object({
  publicId: z.string(),
  name: z.string(),
  key: z.string(),
  type: z.enum(PAYMENT_METHOD_TYPES),
  active: z.boolean(),
  ticketConfig: ticketConfigSchema,
  additionalSettings: paymentMethodAdditionalSettingsSchema,
});

export type TaxConfig = z.infer<typeof taxConfigSchema>;
export type CommissionSettings = z.infer<typeof commissionSettingsSchema>;
export type PaymentMethodAdditionalSettings = z.infer<
  typeof paymentMethodAdditionalSettingsSchema
>;
export type TicketConfig = z.infer<typeof ticketConfigSchema>;
export type PaymentMethodResponse = z.infer<typeof paymentMethodSchema>;
